const Health = () => {
  return <h3>Hey There!!! The App is Healthy</h3>
}
export default Health
